import { Icon } from '@gitbook/spine-icons';
import { clipboard } from '@gitbook/spine-react';

/**
 * Palette options relating to URL (for sections and site spaces),
 * .i.e for copying URL and visiting the published URL.
 * Only enabled when site is published.
 */
export function getPaletteLocationOptions(url: string) {
    return {
        key: 'location-options',
        commands: [
            {
                key: 'visit',
                title: 'Visit',

                icon: Icon.ExternalLink,
                trigger: () => {
                    window.open(url, '_blank');
                },
            },
            {
                key: 'copy',
                title: 'Copy URL',

                icon: Icon.Copy,
                trigger: () => {
                    clipboard.writeText(url);
                },
            },
        ],
    };
}
